export function Tabs() {
    App.document.on('click', '.js-tab', function(e) {
        const $currItem = $(this);
        const tabId = $currItem.data('tab-id');
        const $currTabContent = $(`[data-tab-content='${tabId}']`);

        /** TODO Переделал пока так, иначе если на странице 2+ табов, то скрываются все */
        //$('.js-tab').removeClass('_active');
        $currItem.parent().find('.js-tab').removeClass('_active');
        $currItem.addClass('_active');

        //$('.js-tab-content').removeClass('_active');
        $currTabContent.parent().find('.js-tab-content').removeClass('_active');
        $currTabContent.addClass('_active');

        e.preventDefault();
    });
}

App.document.ready(function() {
    if ($('.js-tabs').length) {
        Tabs();
    }
});
